export default __webpack_public_path__ + "static/media/square.91b206a1.svg";